import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>AVISO DE PRIVACIDAD – LE TOUR DE FRANKIE 2026</h1>
      <p>
        <strong>1. Responsable del Tratamiento</strong>
        <br />
        Le Tour de Frankie, es responsable de recabar sus
        datos personales, del uso que se le dé a los mismos y de su protección.
      </p>
      <p>
        <strong>2. Datos Personales Recabados</strong>
        <br />
        Para las finalidades señaladas en este aviso, recabamos:
        <ul>
          <li>
            <strong>Identificación:</strong> Nombre completo, edad y género.
          </li>
          <li>
            <strong>Contacto:</strong> Correo electrónico, teléfono y contacto
            de emergencia.
          </li>
          <li>
            <strong>Datos Sensibles (Salud):</strong> Tipo de sangre, alergias y
            condiciones médicas relevantes.
          </li>
        </ul>
      </p>
      <p>
        <strong>3. Finalidades del Tratamiento</strong>
        <br />
        Sus datos serán utilizados para:
        <ul>
          <li>
            Gestionar su registro y participación en el evento de ultraciclismo.
          </li>
          <li>
            Logística de entrega de kits (tallas de jersey y puntos de
            recolección).
          </li>
          <li>
            Publicación de resultados, tiempos y nombres en el sitio oficial.
          </li>
          <li>Atención de emergencias y seguridad durante la ruta.</li>
          <li>
            Uso de imagen (fotos/video) para promoción en redes sociales y sitio
            web.
          </li>
        </ul>
      </p>
      <p>
        <strong>4. Deslinde de Responsabilidad y Autosuficiencia</strong>
        <br />
        Al aceptar este aviso y participar en el evento, el usuario reconoce
        que Le Tour de Frankie es una prueba de autosuficiencia. El participante
        deslinda de toda responsabilidad civil o penal a los organizadores por
        accidentes, pérdidas o daños derivados de la competencia, declarando
        que cuenta con el estado de salud y el equipo necesario para completar
        la ruta.
      </p>
      <p>
        <strong>5. Transferencia de Datos</strong>
        <br />
        Sus datos podrán ser transferidos a proveedores de servicios médicos en
        caso de emergencia y a patrocinadores oficiales (como Orbea, Apidura y
        Alba Optics) únicamente para fines promocionales si usted no manifiesta
        su oposición.
      </p>
      <p>
        <strong>6. Derechos ARCO</strong>
        <br />
        Usted puede Acceder, Rectificar, Cancelar u Oponerse al manejo de sus
        datos enviando un correo a: letourdefrankie@gmail.com.
      </p>
      <p>
        <strong>7. Consentimiento</strong>
        <br />
        El registro en letourdefrankie.com implica la aceptación tácita de
        estos términos. El tratamiento de datos de salud e imagen se considera
        aceptado al registrarte y completar el pago de
        inscripción.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
